import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import './App.css';
import affida from './assets/affida.png';
import bracciale from './assets/bracciale.png';
import dot from './assets/dot.png';
import dotx from './assets/dotx.png';
import full from './assets/full.png';
import futura from './assets/futura-bra.png';
import secure from './assets/secure.png';
import Footer from './Footer';
import Header from './Header';

function Home() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);
    const history = useHistory();
    const [sel, setSel] = useState()
    const [professioni, setProfessioni] = useState([])
    const [prof, setProf] = useState(1)
    const [city, setCity] = useState([])
    const [sel2, setSel2] = useState()

    const getProf = () => {
        fetch(`${document.apiURL}/prof`, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setProfessioni(response.map(r => { return { "value": r.id, "label": r.prof_label } }))

            });
    }

    const createBooking = () => {
        history.push(`/booking/${sel !== undefined ? sel : 0}`)

        localStorage.setItem('city', sel2);
    }

    const getCity = () => {
        fetch(document.apiURL + '/city', {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setCity(response.map(r => { return { "value": r.id, "label": r.city } }))
            });
    }

    useEffect(() => {
        getProf();
        getCity();
    }, []);

    const [visible, setVisible] = useState(false);
    const handler = () => setVisible(true);
    const closeHandler = () => {
        setVisible(false);

    };

    return (

        <>
            <Header />
            <div className="main-header">
                <div className="container">
                    <div className="flex">
                        <div className="f1">
                            <div className="flex row center-con">
                                <h1 className="extra c">ConTe per un’assistenza a portata di… polso
                                </h1><img src={futura} className="none-web fut">

                                </img>
                            </div>
                            <div className="col sm-mid">
                                <h2>ConTe è il bracciale intelligente da indossare 24 ore su 24, 7 giorni su 7, per ricevere assistenza immediata in caso di aiuto.</h2></div>
                            <div className="col sm-mid m-p">

                                <button onClick={() => createBooking(prof)} className="button margin-top-min">Ordina online</button>

                                <div className="mid">

                                    <p className="margin-top-min">Altrimenti chiama al numero</p>
                                    <a href='tel:+3908119312726'>081 193 12 726</a></div>

                            </div>
                        </div>
                        <img src={futura} className="none-sma fut" />
                    </div>
                </div>
            </div>





            <div className="main-header main-headers">
                <div className="container containers colonna flex-cp servizi">
                    <div className="text-center m-p">
                        <h2 align="center">Intuitivo e facile da usare</h2>
                        <span className="blue-line">

                        </span>
                        <p align="center" className="margin-top-min margin">Garantiamo: Centrale operativa attiva dalle 09:00 alle 17:00, Assistenza alla persona Domiciliare, Assistenza Domiciliare Infermieristica </p></div>
                    <div className="flex row between scrolling-wrapper-flexbox">


                        <div style={{ cursor: 'pointer' }} className="card" >
                            <img src={affida} className="img-card" />
                            <div className="text-card">
                                <div className="min-height">
                                    <h4>Affidalibità</h4>
                                </div>
                                <p className="sub">Persone anziane o non autosufficienti possono contare in qualsiasi momento di un’assistenza sanitaria immediata. </p>

                            </div>
                        </div>
                        <div style={{ cursor: 'pointer' }} className="card" >
                            <img src={secure} className="img-card" />
                            <div className="text-card">
                                <div className="min-height">
                                    <h4>Sicurezza</h4>
                                </div>
                                <p className="sub">Vivere in sicurezza grazie al sistema di telemonitoraggio e all'attivazione rapida dei soccorsi in caso di emergenza.  </p>

                            </div>
                        </div>
                        <div style={{ cursor: 'pointer' }} className="card" >
                            <img src={full} className="img-card" />
                            <div className="text-card">
                                <div className="min-height">
                                    <h4>Disponibilità full time</h4>
                                </div>
                                <p className="sub">Personale medico disponibile 24 ore su 24, 7 giorni su 7, per assicurare la completa sicurezza ai possessori del bracciale. </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>





            <div className="main-header" style={{ paddingTop: '20px' }}>
                <div className="container">
                    <div className="flex">
                        <div className="f1" style={{ alignSelf: 'center' }}>
                            <div className="flex flex-res center-con">
                                <h2>Funzionalità del bracciale ConTe</h2>
                                <img src={bracciale} className="none-web bra-fot">

                                </img>
                            </div>

                            <div className="col sm-mid p-s">
                                <h3 style={{ textAlign: 'left', fontWeight: '600' }}>Un bracciale di Teleassistenza progettato per persone anziane, non autosufficienti o con patologie croniche, che dispone di:</h3></div>
                            <div className="col m-p">
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Bottone SOS per richiedere consulenza medica o soccorso immediato</p></div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Geolocalizzazione GPS della persona assistita</p></div>



                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Sensore di attività che indica se il bracciale è indossato</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Possibilità di ricevere chiamate personale del centro di monitoraggio.</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Sensore di rilevazione del battito cardiaco per monitorare costantemente i parametri vitali dei possessori del bracciale.</p></div>

                            </div>
                        </div>
                        <img src={bracciale} className="none-sma bra-fot" />
                    </div>
                </div>
            </div>




            <div className="main-header main-headers">
                <div className="con-min container containers colonna flex-cp servizi">
                    <div className="text-center m-p">
                        <h2 align="center">Scegli il piano migliore per te</h2>
                        <span className="blue-line">

                        </span>
                        <p align="center" className="margin-top-min margin">Cerchi sicurezza e convenienza? Il bracciale ConTe te le garantisce entrambe!</p></div>

                </div>
            </div>
            <div class="background" style={{ paddingTop: '20px' }}>
                <div class="container">
                    <div class="panel pricing-table">

                        <div class="pricing-plan" style={{ textAlign: '-webkit-center' }}>
                            <h2 class="pricing-header">Argento</h2>
                            <ul class="pricing-features">

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Bracciale smart</p></div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dotx} style={{ width: '20px', marginRight: '10px', opacity: '0.1' }}></img>  <p>Centrale di telesoccorso</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dotx} style={{ width: '20px', marginRight: '10px', opacity: '0.1' }}></img>  <p>Scheda telefonica</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dotx} style={{ width: '20px', marginRight: '10px', opacity: '0.1' }}></img>  <p>Intervento domiciliare</p></div>
                            </ul>
                            <span class="pricing-price">€129,99</span>
                            <button onClick={() => createBooking(prof)} className="button margin-top-min" style={{ width: '100%' }}>Ordina online</button>
                        </div>

                        <div class="pricing-plan" style={{ textAlign: '-webkit-center' }}>
                            <h2 class="pricing-header">Oro</h2>
                            <ul class="pricing-features">

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Bracciale base</p></div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Centrale di telesoccorso</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Scheda telefonica</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dotx} style={{ width: '20px', marginRight: '10px', opacity: '0.1' }}></img>  <p>Intervento domiciliare</p></div>
                            </ul>
                            <span class="pricing-price">€129<br />+ 24,99 al mese* </span>
                            <button onClick={() => createBooking(prof)} className="button margin-top-min" style={{ width: '100%' }}>Ordina online</button>
                            <p>*minimo 12 mesi</p>
                        </div>

                        <div class="pricing-plan" style={{ textAlign: '-webkit-center' }}>
                            <h2 class="pricing-header">Platino</h2>
                            <ul class="pricing-features">

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Bracciale base</p></div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Centrale di telesoccorso</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Scheda telefonica</p></div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    <img src={dot} style={{ width: '20px', marginRight: '10px' }}></img>  <p>Intervento domiciliare</p></div>
                            </ul>
                            <span class="pricing-price">€129<br />+ 49,99 al mese*</span>
                            <button onClick={() => createBooking(prof)} className="button margin-top-min" style={{ width: '100%' }}>Ordina online</button>
                            <p>*minimo 12 mesi</p>
                        </div>

                    </div>
                </div>
            </div>



            <div className="main-header">
                <div className="container">
                    <div className="flex" style={{ padding: '1.5rem' }}>
                        <div className="f1" >
                            <div className="flex row center-con">
                                <h2 className="c">Portalo ConTe</h2>
                                <img src={futura} style={{ width: '30%', height: '60%' }} className="none-web">
                                </img>
                            </div>
                            <div className="col sm-mid">

                                <p style={{ width: '80%' }}>Sei preoccupato per la sicurezza di una persona anziana o non autosufficiente? Ritrova serenità con il nostro bracciale di teleassistenza!
                                    <br />Prenota un colloquio gratuito e riceverai tutte le informazioni utili.
                                </p>
                                <div style={{ width: 'fit-content' }}>
                                    <button onClick={() => createBooking(prof)} className="button margin-top-min">Ordina online</button>

                                    <div className="mid">
                                        <p className="margin-top-min">Altrimenti chiama al numero</p>
                                        <a href='tel:+3908119312726'>081 193 12 726</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src={futura} style={{ width: '30%', height: '60%' }} className="none-sma" />
                    </div>
                </div>
            </div>


            <Footer />

        </>

    );
}

export default Home;
